let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fh5Vk")).then(() => parcelRequire('1qgZZ'));